export const ADDITIONAL_USERS_OPTIONS = Array.from({ length: 51 }, (_, i) => ({
  value: i,
  label: String(i),
}));
